import { useShallow } from 'zustand/shallow'

import type { Item } from '@/stores/CartStore'
import useCartStore from '@/stores/CartStore'
import useDialogsStore from '@/stores/DialogsStore'
import useLimitStore from '@/stores/LimitStore'
import { ITEMS_NA, PORT_EXPANDER_RNUMBER, PORTS_LIMIT } from '@/util/Hardcoded'

const useExpandedPortsDialog = (item: Item) => {
  const limit = useLimitStore(useShallow(state =>
    state.limits.find(limit =>
      limit.categoryId === item.categoryId
      && limit.limit > 0
      && limit.hubId === item.hubId,
    ),
  ))
  const portExpanderItem = useCartStore(state =>
    state.items.find(
      cartItem => cartItem.hubId === item.hubId
        && cartItem.rNumber === PORT_EXPANDER_RNUMBER,
    ),
  )
  const increase = useCartStore(state => state.increase)
  const toggleDialog = useDialogsStore(state => state.toggle)

  const check = () => {
    if (!limit || !portExpanderItem) return
    const reachedPortLimit = limit.amount >= PORTS_LIMIT
    const alreadyAdded = portExpanderItem.amount > 0
    const isLiteHub = ITEMS_NA.includes(portExpanderItem.partId)

    if (reachedPortLimit && !alreadyAdded && !isLiteHub) {
      toggleDialog('expandedPorts')
      increase(portExpanderItem)
    }
  }

  return { check }
}

export default useExpandedPortsDialog
